import { useState, useEffect } from 'react';
import './AddGiftCardModal.css';

const AddGiftCardModal = ({ isOpen, onClose, onSave, editingCard }) => {
    const [formData, setFormData] = useState({
        carType: '',
        services: [{
            name: '',
            price: '',
            note: '',
            description: []
        }]
    });

    useEffect(() => {
        if (editingCard) {
            setFormData(editingCard);
        }
    }, [editingCard]);

    const handleCarTypeChange = (e) => {
        setFormData({ ...formData, carType: e.target.value });
    };

    const handleServiceChange = (index, field, value) => {
        const updatedServices = [...formData.services];
        updatedServices[index] = {
            ...updatedServices[index],
            [field]: value
        };
        setFormData({ ...formData, services: updatedServices });
    };

    const addService = () => {
        setFormData({
            ...formData,
            services: [
                ...formData.services,
                {
                    name: '',
                    price: '',
                    note: '',
                    description: []
                }
            ]
        });
    };

    const removeService = (index) => {
        const updatedServices = formData.services.filter((_, i) => i !== index);
        setFormData({ ...formData, services: updatedServices });
    };

    const addDescription = (serviceIndex) => {
        const updatedServices = [...formData.services];
        updatedServices[serviceIndex].description.push({ name: '' });
        setFormData({ ...formData, services: updatedServices });
    };

    const handleDescriptionChange = (serviceIndex, descIndex, value) => {
        const updatedServices = [...formData.services];
        updatedServices[serviceIndex].description[descIndex] = { name: value };
        setFormData({ ...formData, services: updatedServices });
    };

    const removeDescription = (serviceIndex, descIndex) => {
        const updatedServices = [...formData.services];
        updatedServices[serviceIndex].description = updatedServices[serviceIndex].description.filter((_, i) => i !== descIndex);
        setFormData({ ...formData, services: updatedServices });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>{editingCard ? 'Edit Gift Card' : 'Add New Gift Card'}</h2>
                    <button className="close-button" onClick={onClose}>&times;</button>
                </div>
                
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Car Type</label>
                        <input
                            type="text"
                            value={formData.carType}
                            onChange={handleCarTypeChange}
                            placeholder="Enter car type"
                            required
                        />
                    </div>

                    <div className="services-section">
                        <h3>Services</h3>
                        {formData.services.map((service, serviceIndex) => (
                            <div key={serviceIndex} className="service-form">
                                <div className="service-header">
                                    <h4>Service {serviceIndex + 1}</h4>
                                    {formData.services.length > 1 && (
                                        <button 
                                            type="button" 
                                            className="remove-button"
                                            onClick={() => removeService(serviceIndex)}
                                        >
                                            Remove Service
                                        </button>
                                    )}
                                </div>

                                <div className="form-group">
                                    <label>Service Name</label>
                                    <input
                                        type="text"
                                        value={service.name}
                                        onChange={(e) => handleServiceChange(serviceIndex, 'name', e.target.value)}
                                        placeholder="Enter service name"
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Price</label>
                                    <input
                                        type="number"
                                        value={service.price}
                                        onChange={(e) => handleServiceChange(serviceIndex, 'price', e.target.value)}
                                        placeholder="Enter price"
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Note</label>
                                    <input
                                        type="text"
                                        value={service.note}
                                        onChange={(e) => handleServiceChange(serviceIndex, 'note', e.target.value)}
                                        placeholder="Enter note"
                                    />
                                </div>

                                <div className="description-section">
                                    <h4>Description Items</h4>
                                    {service.description.map((desc, descIndex) => (
                                        <div key={descIndex} className="description-item">
                                            <input
                                                type="text"
                                                value={desc.name}
                                                onChange={(e) => handleDescriptionChange(serviceIndex, descIndex, e.target.value)}
                                                placeholder="Enter description item"
                                                required
                                            />
                                            <button 
                                                type="button"
                                                className="remove-button"
                                                onClick={() => removeDescription(serviceIndex, descIndex)}
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    ))}
                                    <button 
                                        type="button"
                                        className="add-button"
                                        onClick={() => addDescription(serviceIndex)}
                                    >
                                        Add Description Item
                                    </button>
                                </div>
                            </div>
                        ))}
                        <button 
                            type="button"
                            className="add-button"
                            onClick={addService}
                        >
                            Add Service
                        </button>
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="cancel-button" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className="save-button">
                            Save Changes
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddGiftCardModal; 